export class CountdownTracker {
  el: HTMLElement;
  currentDigit: string;

  constructor(value: number) {
    this.el = this._createElement();
    this.update(value);
  }

  private _createElement(): HTMLElement {
    const el = document.createElement('div');
    el.className = 'card';
    el.innerHTML = `
      <div class="card__top"></div>
      <div class="card__bottom"></div>
      <div class="card__back">
        <div class="card__bottom"></div>
      </div>
    `;
    return el;
  }

  update(val: number) {
    if (isNaN(val)) {
      console.error('Invalid value:', val);
      return;
    }

    const valStr = val.toString();
    if (valStr !== this.currentDigit) {
      const top = this.el.querySelector('.card__top') as HTMLElement;
      const bottom = this.el.querySelector('.card__bottom') as HTMLElement;
      const back = this.el.querySelector('.card__back') as HTMLElement;
      const backBottom = this.el.querySelector(
        '.card__back .card__bottom'
      ) as HTMLElement;

      if (this.currentDigit !== undefined) {
        back.setAttribute('data-value', this.currentDigit);
        bottom.setAttribute('data-value', this.currentDigit);
      }
      this.currentDigit = valStr;
      top.innerText = this.currentDigit;
      backBottom.setAttribute('data-value', this.currentDigit);

      this.el.classList.remove('flip');
      void this.el.offsetWidth;
      this.el.classList.add('flip');
    }
  }
}
